import React, { Suspense } from 'react';

import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import { AppHeader } from '../AppHeader';
import { userService, dataService } from '../_services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



class PaymentFile_ extends React.Component {

	constructor(props) {
		super(props);
		let user = userService.getUser()

		this.state = {
			user: user,
			payments_file: null,
			payments_upload_result: null,

		};
		console.log(props);
		this.initPaymentFileUpload();
	}





	initPaymentFileUpload = () => {
		const user = this.state.user;
		if (user && user.token) {
			console.log("Init Ok")
		}
		else {
			console.log("Init failed")
		}
	}









	handleFileInput = (e) => {
		e.preventDefault();
		// handle validations
		// onFileSelect(e.target.files[0])
		console.log(e.target.files);
		if (e.target.files[0]) {

			this.setState({
				payment_file: e.target.files[0]
			})
		}
	}

	submitInputFile = (e) => {
		e.preventDefault();
		// handle validations
		// onFileSelect(e.target.files[0])
		console.log(this.state.payment_file);
		if (this.state.payment_file) {
			const fileInput = this.state.payment_file;
			var formdata = new FormData();
			formdata.append("file", fileInput, fileInput.name);
			formdata.append("token", this.state.user.token);
			formdata.append("userInfo", this.state.user);

			const requestOptions = {
				method: 'POST',
				//mode: 'no-cors',
				body: formdata,
				headers: { 'x-access-token': this.state.user.token, 'Access-Control-Allow-Origin': "*" },
				// body: JSON.stringify({ token, card_id })
				redirect: 'follow'
			};

			fetch(`${process.env.REACT_APP_REST_URL}/payments/payments-file`, requestOptions)
				.then(dataService.handleResponse)
				.then(result => {
					console.log('result:', result);
					this.setState({ "payments_upload_result": result })
					toast.success(this.props.t('response-ok') + ", " + this.props.t('check-uploaded-payments'), { autoClose: false });
				})
				.catch(error => {
					this.setState({ "payments_upload_result": error })
					console.error('Error:', error);
					toast.error(this.props.t('response-error'), { autoClose: false });
				});

		}
	}





	render() {
		return (
			<Suspense fallback="loading">
				<Container className="col-md-8 autoCenter">
					<ToastContainer autoClose={2000}
						position="top-center"
						className="toast-container"
						toastClassName="dark-toast"
						rtl="true" />
					<AppHeader user={this.state.user} onCardChanged={this.handleCardChanged} />
					<Row style={{ 'minHeight': '200px', 'height': '100%', 'width': '100%' }} >
						<Row style={{ 'width': 'inherit' }}>
							<div className="row" style={{ 'width': 'inherit' }}>
								{/* <Link className="headerLink" to="" onClick={event => this.gotoStep2(event)}
									>{this.props.t('payment-file')}</Link> */}
								{this.state.user.LOGIN_ROLE === 'U'
									&& <div className="elements-line">
										<Row style={{ 'width': 'inherit' }}>
											<div className="file-uploader">
												<input type="file" onChange={this.handleFileInput} accept=".xls,.xlsx" />

												<Link className="headerLink" to="" onClick={e => this.submitInputFile(e)}
												>{this.props.t('payment-file')}</Link>

												{/* {this.state.payments_upload_result?.status && this.state.payments_upload_result?.status === 200 &&
													<span>
														{this.props.t('response-ok')}<br />
														{this.props.t('check-uploaded-payments')}
													</span>
												}
												{this.state.payments_upload_result?.status && this.state.payments_upload_result?.status === 200 &&
													<span>
														{this.props.t('response-error')}
													</span>
												} */}
											</div>
										</Row>
									</div>
								}

							</div>

						</Row>



					</Row>
				</Container>
			</Suspense >
		);
	}
}


const PaymentFile = withTranslation()(PaymentFile_);

export { PaymentFile, PaymentFile_ };

